import { createPortal } from 'react-dom';

// Renderiza los hijos directo en <body>. Para modales que se abren desde un contenedor que los
// recortaría o los dejaría debajo de otras capas (ej. .page de las listas de solicitudes, que tiene
// clip-path y overflow): así cubren toda la pantalla y se apilan con el z-index de tokens.css.
const Portal = ({ children }) => createPortal(children, document.body);

export default Portal;
